<template>
  <UIAnounceModal @close="emit('close')">
    <template #header>
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:p-5 tw:pb-0 tw:text-center">
        <h2 class="tw:font-bold tw:text-white tw:text-3xl">{{ $t('realEstateRental') }}</h2>
        <p class="tw:text-xl">{{ $t('inTortugaDescription') }}</p>
      </div>
    </template>
    <template #default>
      <div
        class="tw:flex tw:flex-col tw:items-center tw:gap-6 tw:mx-auto tw:px-5 tw:py-6 tw:max-w-xl tw:text-xl tw:text-center"
      >
        <p>{{ $t('rentedHouseDescription') }}</p>
        <p>{{ $t('repairBuildings') }}</p>
        <p>{{ $t('importantMarketNote') }}</p>
      </div>
    </template>
    <template #footer>
      <div class="tw:flex tw:justify-center">
        <HalloweenGenericButton @click="handleClose">{{ $t('gotIt') }}</HalloweenGenericButton>
      </div>
    </template>
  </UIAnounceModal>
</template>
<script setup lang="ts">
import { useRentEventStore } from '~/stores/rent-event-store/index.js';

const rent = useRentEventStore();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const handleClose = () => {
  rent.$state.announceModalOpen = false;
  rent.$state.isManorModalOpen = true;
  localStorage.setItem('rent-announced', 'true');
};
</script>
